<template>
  <div>
    <div class="previous-domain">
      <div class="is-size-2">
        {{ $t('assign_domain.previous_title') }}
      </div>
      <div class="is-size-5">
        {{ $t('assign_domain.previous') }}
        <div
          class="select-domain"
        >
          {{ domainData.domainName }}
          <a
            v-if="!alreadyAssigned"
            class=""
            @click="selectedDomain(domainData.domainName)"
          >
            {{ $t('assign_domain.previous_link') }}
          </a>
          <span
            v-else
            class="assigned-domain"
          >
            {{ $t('assign_domain.currently_assigned') }}
          </span>
        </div>
      </div>
    </div>
    <br v-if="success || error">
    <div>
      <span
        v-if="success"
        class="is-size-5"
      >
        Thank you. It could take a few minutes for the domain name to assign.
        <router-link
          :to="{ name: 'MainSection' }"
          class="is-primary"
        >
          {{ $t('assign_domain.link') }}
        </router-link>
      </span>
      <span
        v-if="error"
        class="has-text-danger"
      >
        {{ $t('common.try_again') }}
      </span>
    </div>
  </div>
</template>
<script>
import { SECONDS_IN_MS } from '@/helpers'
import { mapState, mapGetters } from 'vuex'
import assignDomain from '@/mixins/siteplus-generated-urls.js'
export default {
  name: 'PreviousDomain',

  mixins: [assignDomain],

  data () {
    return {
      success: false,
      error: false,
      alreadyAssigned: false
    }
  },

  computed: {
    ...mapState(['services', 'account']),
    ...mapState('domainService', ['domainData']),
    ...mapGetters('domainService', ['domainAllowedStatus', 'hasRegisteredDomain', 'hasPendingDomainSelection', 'hasPendingDomain'])
  },

  watch: {
    siteplusWebsiteDetails: {
      handler (obj) {
        if (obj !== null) {
          if (obj.domainName !== null && this.domainData !== null && (obj.domainName === this.domainData.domainName)) {
            this.alreadyAssigned = true
          }
        }
      }
    }
  },

  methods: {
    async selectedDomain (domainName) {
      const result = await this.assignSiteplusDomainName(domainName, true)

      if (result !== false) {
        this.loading = true
        setTimeout(() => {
          this.success = true
          this.loading = false
        }, SECONDS_IN_MS(2))
      } else {
        this.error = true
        setTimeout(() => {
          this.error = false
        }, SECONDS_IN_MS(3))
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../../sass/_variables.scss';
.previous-domain {
  color: #363636;

  .select-domain {
    margin-top: 10px;
    .button {
      margin-left: 15px;
      vertical-align: middle;
    }
  }

  .assigned-domain {
    color: var(--primary-color);
  }
}
</style>
